<template><div>
  <h1 class="fdd-md--h1"></h1>

  </div></template>
  <script>
  export default {
    mixins: [{
 data() {
  return {
    fddComponentApi: {"componentDesc":{"default":[]},"slots":[],"name":""}
  };
 }
}
]
  }
  </script>
  